module.exports = __webpack_public_path__ + "static/media/illust-404.8322c294.png";